module.exports = __webpack_public_path__ + "img/32.0f0c5506.jpg";